import { AbstractControl } from '@angular/forms';

export function removeFormControl(form, control: string): void {
	form.removeControl(control);
}

export function addFormControl(form, name: string, control: AbstractControl): void {
	form.addControl(name, control);
}
